
<template>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="ie=edge">
  <title>Document</title>
</head>
<body>
  <div id="app">
    <router-view/>
  </div>
</body>
</html>
  
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import "./assets/all";
</style>



// WEBPACK FOOTER //
// src/App.vue